import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const AccordionIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 19.86 20.56"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 20.56)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
    >
      <g strokeLinejoin="round">
        <path d="m19.16 8.7-2.51 3.36-2.74-3.33" />
        <path d="m19.16 16.7-2.51 3.36-2.74-3.33" />
        <path d="m19.16.7-2.51 3.36-2.75-3.33" />
      </g>
      <path d="m.5 9.94h9" />
      <path d="m.5 17.94h9" />
      <path d="m.5 1.94h9" />
    </SVG>
  );
};
